const footer = {
  copyright: "Copyright o 2022 HitPaw . Co , Ltd . All Rights Reserved.",
};

export default footer;
